export const DirectorIDType = {
  SA_ID: 'id',
  PASSPORT: 'passport',
  REFUGEE: 'Refugee',
  ASYLUM_SEEKER: 'Asylum Seeker',
};
